export default "__VITE_ASSET__UbAe3coM__"